import { SidebarLayout } from '@ankor-io/ui-components'

import NavbarComponent from './navbar'
import SidebarComponent from './sidebar'

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      {/* Desktop navbar only */}
      <NavbarComponent className="hidden lg:flex fixed top-0 left-0 right-0 h-14 items-center px-4 shadow-sm z-30 gap-4 border-b border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800" />
      <SidebarLayout
        navbar={<NavbarComponent />}
        sidebar={<SidebarComponent />}
      >
        {/* Main content with proper sidebar spacing */}
        <main className="flex-1 transition-all lg:py-8 duration-200 ease-in-out peer-data-[state=collapsed]:ml-[calc(var(--sidebar-width-icon))] peer-data-[state=expanded]:ml-[var(--sidebar-width)]">
          {children}
        </main>
      </SidebarLayout>
    </>
  )
}

export default Layout
